import React from 'react';
import { observer } from 'mobx-react';
import styled from '@emotion/styled';
import Modal from 'components/modal';
import Button from 'components/button/button';
import { Theme } from '@seedlang/constants';
import { AppUI } from '@seedlang/state';

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 10px 10px 14px;
`;

const Message = styled.div`
  font-size: 16px;
  line-height: 1.5;
  color: #333;
  text-align: center;
`;

const Buttons = styled.div`
  display: flex;
  gap: 10px;
  justify-content: center;
`;

@observer
class FirstCommentModal extends React.Component {
  render() {
    return (
      <Modal
        width={AppUI.layout.isMobile ? '90%' : '440px'}
        height='fit-content'
        top='120px'
        onCloseModal={this.props.onCancel}
        title={this.props.title}
        gradient
      >
        <Wrapper>
          <Message>
            {this.props.message}
          </Message>
          <Buttons>
            <Button
              onClick={this.props.onCancel}
              background={Theme.red}
            >
              {this.props.cancelText}
            </Button>
            <Button
              onClick={this.props.onConfirm}
              background={Theme.green}
            >
              {this.props.confirmText}
            </Button>
          </Buttons>
        </Wrapper>
      </Modal>
    );
  }
}

export default FirstCommentModal;
